export default {
  getUser: (state) => state.user,
};
